@if(templateForPermitForm){
  <mat-icon
    class="help-icon"
    [ngbPopover]="helpText"
    [placement]="placement"
    container="body"
  >
    info
  </mat-icon>
}
@else{
  <i
    class="material-icons help-icon"
    [placement]="placement"
    [ngbPopover]="helpText"
    container="body"
  >
    info
  </i>
}
